import { getAllowedParentOrigins } from '../config/embedConfig';

/** Exact origin match (scheme + host + port). */
export function isAllowedParentOrigin(origin: string): boolean {
  const normalized = normalizeOrigin(origin);
  if (!normalized) {
    return false;
  }
  const allowlist = getAllowedParentOrigins();
  return allowlist.some((allowed) => normalizeOrigin(allowed) === normalized);
}

export function normalizeOrigin(origin: string): string | null {
  try {
    return new URL(origin).origin;
  } catch {
    return null;
  }
}

export function resolveReferrerParentOrigin(): string | null {
  if (!document.referrer) {
    return null;
  }
  try {
    return new URL(document.referrer).origin;
  } catch {
    return null;
  }
}
